<template>
    <div>
        <div class="text-h6 q-pb-md">
            Choose your prefer branch ?
        </div>
        <q-tabs
            v-model="tab"
            vertical
            indicator-color="transparent"
            active-color="primary"
            active-bg-color="primary-2"
            class="text-primary bg-white"
        >
            <q-inner-loading :showing="visible">
                <q-spinner-gears size="50px" color="primary" />
            </q-inner-loading>
            <q-tab
                :disable="visible"
                v-for="(item, index) in store"
                :key="index"
                :name="item.name"
                class="tab"
                @click="onChange(item)"
            >
                <div class="tab-content-class">
                    {{ item.name }}
                </div>
            </q-tab>
        </q-tabs>
    </div>
</template>

<script>
import { QTabs, QTab, QInnerLoading, QSpinnerGears } from "quasar";
import { mini, getBranchAddress } from "@/settings/branchs";
const components = {
    QTabs,
    QTab,
    QInnerLoading,
    QSpinnerGears,
};
export default {
    name: "ChooseBranchDialog",
    components: {
        ...components,
    },
    data() {
        return {
            tab: null,
            store: [],
            visible: false,
        };
    },
    mounted() {
        this.store = mini();
        this.tab = this.$store.state["branch"]["branch"].name;
    },
    methods: {
        async onChange(branch) {
            console.log("branch: ", branch);
            const b = getBranchAddress(branch.name);
            this.$store.dispatch("branch/setBranch", b);
            this.$emit("choosed-branch", branch);
        },
    },
};
</script>

<style scoped>

.tab-content-class {
    text-transform: none;
    justify-content: flex-start;
}
.tab {
    justify-content: flex-start !important;
}
.bg-primary-2 {
    background-color: #c0bfd5;
}
.bg-primary-2::before {
    content: "";
    position: absolute;
    top: 0px;
    height: 2px;
    background-color: #2c2a74;
    left: 0px;
    right: 0px;
}
.bg-primary-2::after {
    content: "";
    position: absolute;
    /* top: 0px; */
    height: 2px;
    background-color: #2c2a74;
    left: 0px;
    right: 0px;
    bottom: 0px;
}

</style>
